<template>
<div>
   
    <vx-card class="">
        <!-- <v-select class="searchSelect" placeholder="검색조건"  :value="page.pageSize" v-model='page.pageSize' :clearable="false" :options="optionData.showNumber"/> -->
        <div class="w-full ">
            <div class="vx-row sm:w-1/2  w-full mb-6 items-center">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>질문 <i class="requier">*</i></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full ">
                    <vs-input class="w-full mr-2" v-model="dataTemplate.title"/>
                </div>
            </div>
            <div class="vx-row sm:w-1/2  w-full mb-6 items-center">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>언어 </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full ">
                    <v-select v-model="dataTemplate.language_code" :options="optionData.language" :reduce="option => option.code" label="name" placeholder="언어 선택" :clearable="false" class="w-full"/>
                </div>
            </div>
            <div class="vx-row sm:w-1/2  w-full mb-6 items-center">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>순서 </span>
                </div>
                <div class="vx-col sm:w-2/3 w-full ">
                    <vs-input class="w-full mr-2" v-model="dataTemplate.sequence_nr"/>
                </div>
            </div>
            <div class="vx-row w-full mb-6 items-center">
                <div class="vx-col sm:w-1/6 w-full">
                    <span>답변 <i class="requier">*</i></span>
                </div>
                <div class="vx-col sm:w-5/6 w-full ">
                    <VueEditor
                        v-model="dataTemplate.content"
                        id="editor"
                        useCustomImageHandler
                        @image-added="handleImageAdded"
                    />
                    
                </div>
            </div>
        </div>
        <!-- <div class="paginationBox">
            <base-pagination :page-count="page.totalPage" v-model="page.currentPage"></base-pagination>
        </div> -->
    </vx-card>
    <div class="vx-row">
        <div class="vx-col m-auto mt-6">
             <vs-button color="danger" v-on:click="$router.push('/support/faq')" type="filled">취소</vs-button>
            <vs-button class="ml-3"  @click="dataSave('confirm')" type="filled">등록</vs-button>
        </div>
    </div>
     
</div>
</template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import { VueEditor } from "vue2-editor";
import axios from 'axios'
export default {
    name: 'genreList',
    components: {
        VueEditor
    },
    data () {
        return {
            optionData,
            fileUrl: `${process.env.VUE_APP_API_URL}/file`,
            headers: {
            Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
            'Access-Control-Allow-Origin': '*',
            },
            dataTemplate : {
                title : '',
                language_code: 'ko',
                sequence_nr: 1,
                content: null,
            },
            total : 0,
            page: {
                pageSize : 50,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
        
            genreTable : {
                column : [
                     
                    {label: '질문',    field: 'fuga', filter: false,width: 250},
                    {label: '등록일', field: 'created_at', filter: false,minWidth: 140,width:140 , formatFn: (data) => {
                        return this.fixDate(data, 'yyyy-MM-dd')
                    }},
                   
                ]
            }
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
        })
    },
    computed: {
    
    },
    watch: {
         
    },
    methods: {
        
        
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
            // An example of using FormData
            // NOTE: Your key could be different such as:
            // formData.append('file', file)
            var formData = new FormData();
            formData.append("file", file);
            axios({
                url: this.fileUrl,
                method: "POST",
                data: formData,
                headers: {
                "Content-Type": "multipart/form-data",
                ...this.headers 
                }   
            }).then(result => {
                console.log(result)
                const url = result.data[0].remote_path; // Get url from response
               setTimeout(() => {
                      Editor.insertEmbed(cursorLocation, "image", url  );
                }, 500);
                resetUploader();
            })
            .catch(err => {
                console.log(err);
            });
        },
        dataSave(event){
            let payload ={
                ...this.dataTemplate,
                sequence_nr: parseInt(this.dataTemplate.sequence_nr) || 0
            }
            if(this.valCheck(this.dataTemplate.title) && this.valCheck(this.dataTemplate.content)  ){
                this.alert({msg : '질문과 내용을 확인해주세요.'})
                return false
            }
            this.loadingShow()
            this.$store.dispatch('POST_FAQ', payload)
            .then(result =>{
                this.alert({msg : '등록이 완료되었습니다.'})
                this.$router.push('/support/faq')
                this.loadingHide()
                
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
